<template>
  <div class="caculate-result">
    <p class="title">{{ title }}</p>
    <p class="desc">Rates shown may be different than the actual charges</p>
    <div class="house">
      <div class="house-title">
        <span
          >Storage warehouse
          <i-poptip transfer trigger="hover" class="tip" width="320" placement="right">
            <i-icon type="ios-help-circle-outline" />
            <div slot="content" class="tip-content" style="white-space: pre-line;">
              <span
                >We recommend a storage warehouse for you by default, and the total freight generated by this warehouse
                is the cheapest. You can also select another warehouse based on your needs.</span
              >
            </div>
          </i-poptip>
        </span>
        <div class="store">
          <img src="../../../assets/imgs/calculate-wavehouse.png" />
          <span>{{ curHouse && curHouse.name }}</span>
        </div>
      </div>
      <div class="desc">
        <span />
        <i-dropdown trigger="click" style="">
          <span>Change</span>
          <i-dropdown-menu slot="list">
            <i-dropdown-item v-for="item in warehouse" :key="item.code" @click.native="changeWaveHouse(item)">{{
              item.name
            }}</i-dropdown-item>
          </i-dropdown-menu>
        </i-dropdown>
      </div>
    </div>
    <div v-if="!loading" class="content">
      <div class="form">
        <div class="input">
          <div class="form-title">
            <label>Send shipping</label>
            <span>${{ calculate.sendCost }}</span>
          </div>
          <div class="form-info">
            <span class="tips">Shipped by FedEx to storage warehouse</span>
            <span class="info">${{ calculate.sendCostFedex }}</span>
          </div>
        </div>
        <div v-if="calculate.storeCost" class="input">
          <div class="form-title">
            <label>Storage</label>
            <label v-if="calculate.storeCost == 0" class="info">TBD</label>
            <span v-else>${{ calculate.storeCost }}</span>
          </div>
          <div class="form-info">
            <label class="tips">Store your items</label>
            <label class="tips">${{ calculate.storePrice }}/lb per day</label>
          </div>
        </div>
        <div class="input">
          <div class="form-title">
            <label>Return shipping</label>
            <label v-if="calculate.backCost == 0" class="info">TBD</label>
            <span v-else>${{ calculate.backCost }}</span>
          </div>
          <div class="form-info">
            <span class="tips">Shipped by FedEx to destination</span>
            <label v-if="calculate.backCost == 0" class="info"></label>
            <span v-else class="info">${{ calculate.backCostFedex }}</span>
          </div>
        </div>
      </div>
      <div class="serice">
        <div class="line">
          <p class="title">Other optional service</p>
          <ul class="info">
            <li class="info-item info-tag">
              Insurance
              <i-poptip transfer trigger="hover" class="tip" width="320" placement="right">
                <span class="tag">Price</span>
                <div slot="content" class="tip-content" style="white-space: pre-line;">
                  <Tips
                    desc="You can buy insurance for packages in storage. The insurance fees 2% of the estimated item value. Suppose you think that the value of the items in the package is $100, you need to pay $2 for insurance."
                  />
                </div>
              </i-poptip>
            </li>
            <li class="info-item info-tag">
              Pick-up
              <i-poptip transfer class="tip" width="320" trigger="hover" placement="right">
                <span class="tag">Price</span>
                <div slot="content" class="tip-content">
                  <Tips
                    title="Pick-up"
                    :price="'$' + PICKUP_PRICE + ' / times'"
                    desc="Schedule a pickup at your location for FedEx to send packages easily"
                  />
                  <Tips
                    title="Drop-off"
                    price="Free"
                    desc="Drop them off at your local nearest FedEx locations by yourself"
                  />
                </div>
              </i-poptip>
            </li>
            <li class="info-item info-tag">
              Signature
              <i-poptip transfer class="tip" width="320" trigger="hover" placement="right">
                <span class="tag">Price</span>
                <div slot="content" class="tip-content">
                  <Tips
                    title="Direct Signature"
                    :price="'$' + DIRECT_PRICE + ' / box'"
                    desc="Someone at the recipient's address may sign for delivery."
                  />
                  <Tips
                    title="Adult Signature"
                    :price="'$' + ADULT_PRICE + ' / box'"
                    desc="An adult at the delivery address must sign for delivery. Photo identification is required."
                  />
                </div>
              </i-poptip>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div v-else class="loading">
      <i-spin fix>
        <i-icon type="ios-loading" size="40" class="spin-icon-load" />
      </i-spin>
    </div>
    <div class="footer">
      <div class="total">
        <span>Total</span>
        <span class="price">${{ calculate.totalCost }}</span>
      </div>
      <Button size="large" style="white-space: nowrap" @click="nextStep">Get started</Button>
    </div>
  </div>
</template>

<script>
import Button from '../../../components/button/Button';
import Tips from '../../../components/tips/Tips';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'MoveCaculateResult',
  components: {
    Button,
    Tips,
  },
  props: {
    curHouse: {
      type: Object,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
    calculate: {
      type: Object,
      default: function() {
        return {};
      },
    },
  },
  data() {
    return {
      PICKUP_PRICE: '-.--',
      ADULT_PRICE: '-.--',
      DIRECT_PRICE: '-.--',
    };
  },
  created() {
    console.log('created!!!!!');
  },
  mounted() {
    console.log('mounted!!!!!');
    this.initPrice();
  },
  methods: {
    nextStep() {
      this.$emit('nextStep');
    },
    changeWaveHouse(item) {
      this.$emit('changeWaveHouse', item);
    },
    initPrice() {
      this.initPickUp();
      this.initReturnPrice();
    },
    initPickUp() {
      console.log('initPickUp');
      this.getPickUpPrice()
        .then(res => {
          if (res.success) {
            this.PICKUP_PRICE = res.data;
          } else {
            setTimeout(() => {
              this.initPickUp();
            }, 1500);
          }
        })
        .catch(() => {
          setTimeout(() => {
            this.initPickUp();
          }, 1500);
        });
    },
    initReturnPrice() {
      this.returnPriceLoading = true;
      this.getReturnPrice()
        .then(res => {
          this.returnPriceLoading = false;
          if (res.success) {
            let { ADULT, DIRECT } = res.data;
            this.ADULT_PRICE = ADULT;
            this.DIRECT_PRICE = DIRECT;
          } else {
            setTimeout(() => {
              this.initReturnPrice();
            }, 1500);
          }
        })
        .catch(() => {
          setTimeout(() => {
            this.initReturnPrice();
          }, 1500);
        });
    },
    ...mapActions('send', ['getPickUpPrice', 'getReturnPrice']),
  },
  computed: {
    title() {
      if (this.loading) {
        return 'Estimated costs';
      }
      return 'Estimated rates';
    },
    ...mapState('calculate', ['warehouse']),
  },
};
</script>

<style lang="less" scoped>
@import '../../../assets/css/main.less';
@import '../../../assets/fonts/font.less';
.caculate-result {
  padding: 24px 24px 0;
  flex-direction: column;
  height: 100%;
  padding-bottom: 78px;
  .content {
    max-height: calc(~'100% - 144px');
    overflow: auto;
  }
  .title {
    .font-regular;
    font-size: 18px;
    font-weight: 400;
    color: @app-black-color;
    text-shadow: 0px 2px 10px rgba(191, 191, 193, 0.3);
  }
  .desc {
    .font-light;
    font-size: 12px;
    font-weight: 300;
    color: @app-black-color;
    text-shadow: 0px 2px 10px rgba(191, 191, 193, 0.3);
  }
  .loading {
    position: relative;
    height: 200px;
  }
  .form {
    margin-top: 10px;
    .input {
      height: 75px;
      border-bottom: 1px solid #eeeff0;
      .form-title {
        padding: 18px 0 6px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        label {
          .font-regular;
          font-size: 14px;
          font-weight: 400;
          color: @app-black-color;
          line-height: 18px;
          text-shadow: 0px 2px 10px rgba(191, 191, 193, 0.3);
          &.info {
            .font-light;
            font-size: 12px;
          }
        }
        span {
          .font-medium;
          font-size: 14px;
          font-weight: 500;
          color: @app-black-color;
          text-shadow: 0px 2px 10px rgba(191, 191, 193, 0.3);
        }
      }
      .form-info {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        .tips {
          .font-light;
          font-size: 12px;
          font-weight: 300;
          color: @app-body-color;
          text-shadow: 0px 2px 10px rgba(191, 191, 193, 0.3);
        }
        .info {
          .tips;
          text-decoration: line-through;
        }
      }
    }
  }
  .serice {
    padding: 3px 0 41px;
    border-bottom: 1px solid #eeeff0;
    .line {
      margin-top: 16px;
      .title {
        .font-light;
        font-size: 14px;
        font-weight: 300;
        color: @app-black-color;
        text-shadow: 0px 2px 10px rgba(191, 191, 193, 0.3);
      }
      .info {
        padding-top: 6px;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        .info-item {
          .font-light;
          display: flex;
          flex-direction: row;
          align-items: center;
          font-size: 12px;
          font-weight: 300;
          color: @app-body-color;
          margin-top: 10px;
          text-shadow: 0px 2px 10px rgba(191, 191, 193, 0.3);
          &:before {
            content: ' ';
            display: inline-block;
            width: 4px;
            height: 4px;
            background-color: @app-color;
            border-radius: 4px;
            margin-right: 6px;
          }
          .tag {
            .font-light;
            content: 'Price';
            display: inline-block;
            transform: scale(0.6);
            margin-left: -4px;
            font-size: 16px;
            font-weight: 300;
            color: #ffffff;
            width: 44px;
            text-align: center;
            height: 20px;
            background: @app-tag-color;
            box-shadow: 0px 4px 20px 0px rgba(191, 191, 193, 0.3);
            border-radius: 2px;
            margin-top: 5px;
            cursor: default;
          }
          &.info-tip {
            margin-right: 26px;
            .tip {
              padding: 0 6px;
              font-size: 15px;
            }
          }
        }
      }
    }
  }
  .footer {
    height: 78px;
    display: flex;
    flex-direction: row;
    align-items: center;
    position: absolute;
    background-color: #fff;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 0 24px;
    .total {
      width: 290px;
      span {
        .font-regular;
        font-size: 16px;
        font-weight: 400;
        color: @app-black-color;
        text-shadow: 0px 2px 10px rgba(191, 191, 193, 0.3);
      }
      .price {
        padding-left: 26px;
      }
    }
  }
  .house {
    border-radius: 4px;
    border: 1px solid #eeeff0;
    margin-top: 20px;
    display: flex;
    padding: 16px 20px;
    flex-direction: column;
    .house-title {
      .font-regular;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      font-size: 14px;
      font-weight: 400;
      color: #262626;
      line-height: 18px;
      img {
        width: 18px;
        height: 18px;
        margin-right: 12px;
      }
    }
    .desc {
      .font-light;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      padding-top: 10px;
      font-size: 12px;
      font-weight: 300;
      color: #5bc0d7;
      line-height: 15px;
      span {
        cursor: pointer;
      }
    }
  }
}
</style>
